import { CardContent, Box} from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import useWebContext from '../../hooks/useWebContext';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { OutlinedMediaLinkCard } from '../../ui-parts/OutlinedMediaLinkCard';
import { utility } from '../../utility';
import { MyMTooltip } from '../../ui-elements/MyMToolTip';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { useMediaQuery } from '../../hooks/useMediaQuery';

// 2024.9.16 MyMine Version2.0対応 Modify Start
export const HomeBusinessAreaCard = ({ screenId }) => {
  const { controlSettings, screenSettings} = useWebContext(screenId);
  const isPc = useMediaQuery('1200px <= width');
  const isXs = useMediaQuery('(min-width:0px) and (max-width:599px)');
  const isSm = useMediaQuery('(min-width:600px) and (max-width:899px)');
  const isMd = useMediaQuery('(min-width:900px) and (max-width:1349px)');
  const isLg = useMediaQuery('(min-width:1350px) and (max-width:1499px)');
  const isXl = useMediaQuery('(min-width:1500px) and (max-width:1999px)');
  const isXxl = useMediaQuery('(min-width:2000px)');

  const businessAreaCardPropList =
    [
      {
        description: controlSettings.LabelList.lblSalesText,
        caption: controlSettings.LabelList.lblSales,
        mediaImageFileName: controlSettings.ImageList.imgSales,
        navigateTo: "/MyM102/MyM301",
      },
      {
        description: controlSettings.LabelList.lblServiceText,
        caption: controlSettings.LabelList.lblService,
        mediaImageFileName: controlSettings.ImageList.imgService,
        navigateTo: "/MyM102/MyM303",
      },
      {
        description: controlSettings.LabelList.lblSPSText,
        caption: controlSettings.LabelList.lblSPS,
        mediaImageFileName: controlSettings.ImageList.imgSPS,
        navigateTo: "/MyM102/MyM306",
      },
      ...(screenSettings.MarketInsightOnFlg === 1
        ? [{
          description: controlSettings.LabelList.lblMarketingText,
          caption: controlSettings.LabelList.lblMarketing,
          mediaImageFileName: controlSettings.ImageList.imgMarketing,
          navigateTo: "/MyM102/MyM324",
        }]
        : []
      ),
      {
        description: controlSettings.LabelList.lblDigitalText,
        caption: controlSettings.LabelList.lblDigital,
        mediaImageFileName: controlSettings.ImageList.imgDigital,
        navigateTo: "/MyM102/MyM309",
      },
      {
        description: controlSettings.LabelList.lblAHSText,
        caption: controlSettings.LabelList.lblAHS,
        mediaImageFileName: controlSettings.ImageList.imgAHS,
        navigateTo: "/MyM102/MyM313",
      },
      {
        description: controlSettings.LabelList.lblTrainingText,
        caption: controlSettings.LabelList.lblTraining,
        mediaImageFileName: controlSettings.ImageList.imgTraining,
        navigateTo: "/MyM102/MyM317",
      },

    ];
  //2025.7.7 MyMine Version3.0対応 Add Start
  const smallBusinessAreaCardPropList =
    [
      {
        caption: controlSettings.LabelList.lblAssetLibrary,
        mediaImageFileName: controlSettings.ImageList.imgAHS,
        navigateTo: "/MyM102/MyM325",
      },
      {
        caption: controlSettings.LabelList.lblItApplications,
        mediaImageFileName: controlSettings.ImageList.imgItApplications,
        navigateTo: "/MyM102/MyM305",
      },
    ]

  const maxLength =
    (isXs && screenSettings.IsXsBusinessAreaContentMaxLength) ||
    (isSm && screenSettings.IsSmBusinessAreaContentMaxLength) ||
    (isMd && screenSettings.IsMdBusinessAreaContentMaxLength) ||
    (isLg && screenSettings.IsLgBusinessAreaContentMaxLength) ||
    (isXl && screenSettings.IsXlBusinessAreaContentMaxLength) ||
    (isXxl && screenSettings.IsXxlBusinessAreaContentMaxLength);
  //2025.7.7 MyMine Version3.0対応 Add End

  return (
    <OutlinedCustomCard sx={{ overflow: 'auto' }}>
      <Grid container>
        <Grid item xs={12} md={12} lg={9.5} xxl={9}>
          <CardContent style={{ paddingBottom: '5px' }}>
            <Grid
              container
              className='px-3'
              sx={{
                '.caption ': { fontSize: '1.1rem !important' },
                '.description': { fontSize: '0.9rem !important'}
              }}
              columnSpacing={6}
              rowSpacing={1} >
              {businessAreaCardPropList.map((businessAreaCardProp, i) =>
                <Grid item xs={12} sm={3} md={3} lg={3} key={i}>
                  {businessAreaCardProp.description && businessAreaCardProp.description.length > maxLength ?
                    (
                      <MyMTooltip title={businessAreaCardProp.description} >
                        <div>
                          <OutlinedMediaLinkCard
                            screenId={screenId}
                            mediaHeight={60}
                            descriptionHeight={80}
                            descriptionMaxHeight={80}
                            {...businessAreaCardProp}
                            description={utility.convertEllipsisFormat(businessAreaCardProp.description, maxLength)}
                          />
                        </div>
                      </MyMTooltip>
                    ) :
                    (
                      <div>
                        <OutlinedMediaLinkCard
                          screenId={screenId}
                          mediaHeight={60}
                          descriptionHeight={80}
                          descriptionMaxHeight={80}
                          {...businessAreaCardProp}
                          description={utility.convertEllipsisFormat(businessAreaCardProp.description, maxLength)}
                        />
                      </div>
                    )
                  }
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Grid>
        {/*2025.7.7 MyMine Version3.0対応 Add Start*/}
        {isPc &&
          <Grid item md={0.5} xxl={0.8} >
            <Box
              sx={{
                width: '1px',
                backgroundColor: '#acacac',
                height: '100%',
                mx: 0.9, // 左右のマージン
                my: '5.5px', // 上に余白
              }}
            />
          </Grid>
        }
        {/*2025.7.7 MyMine Version3.0対応 Add End*/}
        {/*2025.7.7 MyMine Version3.0対応 Add Start*/}
        <Grid item xs={12} md={12} lg={1.5}>
          <CardContent style={{ paddingBottom: '5px' }}>
            <Grid
              container
              className='px-3'
              sx={{
                '.caption ': { fontSize: '1.3rem !important' },
                '.description': { fontSize: '0.9rem !important' }
              }}
              columnSpacing={6}
              rowSpacing={1} >
              {smallBusinessAreaCardPropList.map((smallBusinessAreaCardProp, i) =>
                <Grid item xs={12} md={12} key={i} className="d-flex align-items-center justify-content-center">
                  {isPc ? 
                    <>
                      <NavigateLink to={smallBusinessAreaCardProp.navigateTo} underline="none">
                        <Box sx={{
                          height: '60px',
                          width: '210px',
                          backgroundColor: '#7F7F7F',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '10px'
                        }}>
                          <MyMLabel fontSize='1.3rem' sx={{ color: 'white' }}>{smallBusinessAreaCardProp.caption}</MyMLabel>
                        </Box>
                      </NavigateLink>
                    </>
                    :
                    <>
                      <NavigateLink to={smallBusinessAreaCardProp.navigateTo} underline="none" width='100%'>
                        <Box sx={{
                          height: '60px',
                          width: 'auto',
                          backgroundColor: '#7F7F7F',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '10px'
                        }}>
                          <MyMLabel fontSize='1.3rem' sx={{ color: 'white' }}>{smallBusinessAreaCardProp.caption}</MyMLabel>
                        </Box>
                      </NavigateLink>
                    </>
                   }
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Grid>
        {/*2025.7.7 MyMine Version3.0対応 Add End*/}
      </Grid>
    </OutlinedCustomCard>
  );
};
// 2024.9.16 MyMine Version2.0対応 Modify End